import { Route, Trophy, BarChart3, TrendingUp, ArrowRightLeft } from "lucide-react";
import { LRDirectComingSoonToolCard } from "./LRDirectAtlasCard";

/** LR Direct Lane Optimizer — visual placeholder (no LR Direct logic yet). */
export default function LRDirectLaneOptimizerCard() {
  return (
    <LRDirectComingSoonToolCard
      icon={Route}
      title="ATLAS Lane Optimizer"
      bannerIcon={Trophy}
      bannerText="Rank your LR Direct corridors"
      bannerTone="amber"
      description="Your direct lanes ranked by volume, awarded rate, and time-to-award so you know where your network performs best."
      stats={[
        { label: "Volume", value: "--", icon: BarChart3 },
        { label: "Avg Rate", value: "--", icon: TrendingUp },
        { label: "Fastest", value: "--", icon: Route },
      ]}
      listTitle="Top lanes"
      rows={[
        { label: "Lane ranking not available yet", value: "--" },
        { label: "Lane ranking not available yet", value: "--" },
        { label: "Lane ranking not available yet", value: "--" },
      ]}
      ctaLabel="View All Lanes"
    >
      <div className="flex items-center gap-1.5 text-[10px] text-muted-foreground">
        <ArrowRightLeft className="h-2.5 w-2.5" />
        Built on direct_loads once LR Direct analytics ship.
      </div>
    </LRDirectComingSoonToolCard>
  );
}
